/**
 * eleveRoutes.jsx — Routes de l'Espace Élève back-office (/eleve/*)
 * Rôles : eleve | admin (admin en mode aperçu).
 */
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import EleveLayout from '../components/EleveLayout';
import EleveDashboard from '../pages/eleve/DashboardPage';
import EleveCours from '../pages/eleve/CoursPage';
import EleveProgression from '../pages/eleve/ProgressionPage';
import EleveLivret from '../pages/eleve/LivretPage';
import EleveBilans from '../pages/eleve/BilansPage';
import ElevePermisBlanc from '../pages/eleve/PermisBlancPage';
import ElevePlanning from '../pages/eleve/PlanningPage';
import EleveMessages from '../pages/eleve/MessagesPage';
import MesMoniteursPage from '../pages/eleve/MesMoniteursPage';
import MesShortsPage from '../pages/eleve/MesShortsPage';
import ContactAdminPage from '../pages/ContactAdminPage';

export const EleveRoutes = () => (
  <Route path="/eleve" element={
    <ProtectedRoute roles={['eleve', 'admin']}>
      <EleveLayout />
    </ProtectedRoute>
  }>
    <Route index element={<Navigate to="/eleve/dashboard" replace />} />
    <Route path="dashboard" element={<EleveDashboard />} />
    <Route path="cours" element={<EleveCours />} />
    <Route path="progression" element={<EleveProgression />} />
    <Route path="livret" element={<EleveLivret />} />
    <Route path="bilans" element={<EleveBilans />} />
    <Route path="permis-blanc" element={<ElevePermisBlanc />} />
    <Route path="planning" element={<ElevePlanning />} />
    <Route path="messages" element={<EleveMessages />} />
    <Route path="mes-moniteurs" element={<MesMoniteursPage />} />
    <Route path="mes-shorts" element={<MesShortsPage />} />
    <Route path="contact-admin" element={<ContactAdminPage />} />
  </Route>
);

export default EleveRoutes;
